/** 建置時品牌（Vite env）。辰銪為預設 fallback；英瑋走 `.env.ew`。 */

const DEFAULT_ASSET_URL = '/brands/chenyo/logo.svg';

/**
 * 可選資產 URL：trim 後空字串 → null（不 fallback）。
 * @param {unknown} raw
 * @returns {string | null}
 */
export function resolveOptionalAssetUrl(raw) {
  if (raw == null) {
    return null;
  }

  const trimmed = String(raw).trim();
  return trimmed === '' ? null : trimmed;
}

/**
 * env 完全未定義 → 預設資產；空字串／空白 → null。
 * @param {unknown} envValue
 * @returns {string | null}
 */
function resolveBrandAssetUrl(envValue) {
  if (envValue === undefined) {
    return DEFAULT_ASSET_URL;
  }

  return resolveOptionalAssetUrl(envValue);
}

export const brand = {
  id: import.meta.env.VITE_BRAND_ID || 'chenyo',
  companyName: import.meta.env.VITE_COMPANY_NAME || '辰銪科技',
  logoUrl: resolveBrandAssetUrl(import.meta.env.VITE_LOGO_URL),
  faviconUrl: resolveBrandAssetUrl(import.meta.env.VITE_FAVICON_URL),
  documentTitle: import.meta.env.VITE_DOCUMENT_TITLE || '辰銪科技 ERP',
};

export function applyBrand() {
  if (typeof document === 'undefined') {
    return;
  }

  document.title = brand.documentTitle;

  if (brand.faviconUrl == null) {
    return;
  }

  const icon = document.querySelector("link[rel='icon']");
  if (icon) {
    icon.setAttribute('href', brand.faviconUrl);
    return;
  }

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = brand.faviconUrl;
  document.head.appendChild(link);
}
